import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../AuthContext";
import { logIn } from "../services/Login";
import { LoginValid } from "../validations/LoginValid";
import "./LoginNew.css";

function Login() {
  const { authenticated, login } = useAuth();
  const navigate = useNavigate();
  const [loginField, setLoginField] = useState({ userName: "", password: "" });
  const [loginFieldErr, setLoginFieldErr] = useState({
    userName: "",
    password: "",
  });
  const [showpassword, setshowpassword] = useState("password");
  const [eye, seteye] = useState("bi-eye-slash");

  const showPassword = () => {
    if (showpassword === "password") {
      setshowpassword("text");
      seteye("bi-eye");
    } else {
      setshowpassword("password");
      seteye("bi-eye-slash");
    }
  };

  useEffect(() => {
    if (!authenticated) {
      navigate("/", { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [authenticated, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginField({ ...loginField, [name]: value });
    let checkLogin = LoginValid(name, value);
    setLoginFieldErr({ ...loginFieldErr, [name]: checkLogin });
  };

  const onLogin = async (event) => {
    event.preventDefault();
    for (let key in loginField) {
      let checkLogin = LoginValid(key, loginField[key]);
      setLoginFieldErr({ ...loginFieldErr, [key]: checkLogin });
      if (checkLogin !== "") {
        return false;
      }
    }
    console.log("call");
    let LoginData = {
      email: loginField.userName,
      password: loginField.password,
    };
    let result = await logIn(LoginData);
    if (result.status) {

      let token = result.token;
      localStorage.setItem("jwtToken", token);
      localStorage.setItem("userType", result.type);
      login();
      toast.success(result.message);
      setTimeout(function () {
        navigate("/dashboard", { replace: true });
      }, 1000);
      return false;
    } else {
      toast.dismiss();
      toast.error(result.message);
      return;
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-card">
        <div className="login-logo">
          <img src="/assets/img/logo.png" alt="Logo" />
        </div>

        <div className="login-header-text">
          <h2 className="login-title">Welcome Back</h2>
          <p className="login-subtitle">Enter your credentials to access your account</p>
        </div>

        <form onSubmit={onLogin} noValidate>
          <div className="custom-form-group">
            <label htmlFor="yourUsername" className="custom-label">
              Email
            </label>
            <div className="custom-input-wrapper">
              <i className="bi bi-person input-icon-left"></i>
              <input
                type="text"
                name="userName"
                placeholder="Enter your username"
                className="custom-form-control"
                id="yourUsername"
                value={loginField.userName}
                onChange={handleChange}
              />
            </div>
            {loginFieldErr.userName && (
              <span className="error-txt">
                <i className="bi bi-exclamation-circle"></i> {loginFieldErr.userName}
              </span>
            )}
          </div>

          <div className="custom-form-group">
            <label htmlFor="yourPassword" className="custom-label">
              Password
            </label>
            <div className="custom-input-wrapper">
              <i className="bi bi-lock input-icon-left"></i>
              <input
                type={showpassword}
                name="password"
                placeholder="Enter your password"
                className="custom-form-control"
                id="yourPassword"
                value={loginField.password}
                onChange={handleChange}
              />
              <i
                className={`bi ${eye} input-icon-right`}
                onClick={showPassword}
                role="button"
                tabIndex={0}
              ></i>
            </div>
            {loginFieldErr.password && (
              <span className="error-txt">
                <i className="bi bi-exclamation-circle"></i> {loginFieldErr.password}
              </span>
            )}
          </div>

          <button className="custom-login-btn" type="submit">
            Sign In
          </button>
        </form>


      </div>
    </div>
  );
}

export default Login;
